import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck } from 'lucide-react';
import { apiGet } from '../../lib/api.js';
import { PRODUCER_STATUS_KEY } from './ProducerPageBanner.jsx';

/**
 * Optional last onboarding step, shown after Account Sync.
 * @returns {JSX.Element|null}
 */
export default function ProducerPageNextStep() {
  const { data } = useQuery({
    queryKey: PRODUCER_STATUS_KEY,
    queryFn: () => apiGet('/producer-page/status').catch(() => null),
    staleTime: 60_000,
  });
  if (data?.published) return null;
  return (
    <div className="panel mx-auto flex w-full max-w-5xl flex-wrap items-center gap-3 border border-white/10 p-4" data-testid="next-step-producer-page">
      <BadgeCheck className="h-5 w-5 shrink-0 text-civix-purpleSoft" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">Next (optional): Set up your Producer Validation Page</div>
        <div className="text-xs text-white/60">A public page with your licenses, carriers and credentials, so leads can verify who you are.</div>
      </div>
      <Link to="/settings?tab=producer-page" className="inline-flex items-center gap-1 rounded-lg bg-civix-purple px-4 py-2 text-xs font-bold text-white hover:bg-civix-purple/90">
        Set up Producer Page <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
